<template>
  <div>
    <AlertBanner class="m-4 mb-8" component-style="warning">
      <ul class="text-sm">
        <li v-for="(message, index) in positionErrorMessage" :key="index">
          {{ message }}
        </li>
      </ul>
    </AlertBanner>
    <div id="location-instructions" class="flex flex-col px-8">
      <ul class="flex flex-col gap-4">
        <li
          v-for="(instruction, index) in instructions"
          :key="index"
          class="flex items-center justify-items-start gap-4"
        >
          <img
            v-if="instruction.icon"
            :alt="instruction.content"
            :src="instruction.icon"
            class="h-10 w-10"
          />
          <span v-else class="h-10 w-10" />
          <p>{{ instruction.content }}</p>
        </li>
      </ul>
      <div class="ml-auto mt-4">
        <button
          class="px-4 py-2 text-blue-500 underline"
          type="button"
          @click="returnToLogin"
        >
          I have updated my settings
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import AlertBanner from '@/components/AlertBanner.vue'
  import { defineComponent } from 'vue'
  import config, { instruction } from '@/config'
  import locationSettingsInstructions from '@/config/help/locationSettingsInstructions'
  import { isIOS } from '@/utilities/device'
  import { useFingerprintStore } from '@/storage/fingerprint'
  import { storeToRefs } from 'pinia'
  import { useNativeScanStore } from '@/storage/nativeScan'
  import resetStore from '@/components/use/resetStore'
  import { useUserPositionStore } from '@/storage/userPosition'

  export default defineComponent({
    name: 'LocationHelp',
    components: { AlertBanner },

    setup() {
      const { getBrowser } = storeToRefs(useFingerprintStore())
      const { positionErrorMessage, resetPositionErrorMessage } =
        useUserPositionStore()

      const getInstructions = (): instruction[] => {
        if (isIOS() && getBrowser.value?.includes('Safari')) {
          return locationSettingsInstructions.iosSafari
        }
        if (!isIOS() && getBrowser.value?.includes('Chrome')) {
          return locationSettingsInstructions.androidChrome
        }
        if (!isIOS() && getBrowser.value?.includes('Samsung')) {
          return locationSettingsInstructions.androidSamsung
        }
        return [
          { content: 'Turn precise location on' },
          { content: "Refer to your mobile's manual for instructions" },
        ]
      }

      const returnToLogin = async () => {
        const uuid = useNativeScanStore().uuid
        resetStore(true)

        const url = new URL(window.location.origin + config.redirects.loginPath)
        if (uuid.length > 0) {
          url.searchParams.set('uuid', uuid)
        }
        resetPositionErrorMessage()
        window.location.replace(url.toString())
        return
      }

      return {
        instructions: getInstructions(),
        positionErrorMessage,
        returnToLogin,
      }
    },
  })
</script>
